import React from 'react';
import { cn } from '../cn.js';

/**
 * Design-system text input.
 * @param {'default'|'error'|'warning'|'colored'} [state]
 */
const Input = ({
    label,
    value,
    onChange,
    placeholder,
    state = 'default',
    errorText,
    warningText,
    fullWidth = false,
    className = '',
    type = 'text',
    id,
    disabled = false,
    ...rest
}) => {
    const resolvedState = errorText ? 'error' : warningText ? 'warning' : state;
    const field = (
        <div
            className={cn(
                errorText || warningText ? 'input__wrapper' : 'input__container',
                'flex w-full flex-col',
                fullWidth ? 'max-w-none' : 'max-w-[376px]',
                fullWidth && (errorText || warningText
                    ? 'input__wrapper_full-width'
                    : 'input__container_full-width'),
            )}
        >
            <input
                id={id}
                type={type}
                disabled={disabled}
                className={cn(
                    'block__content input box-border w-full rounded-input border border-solid border-light-grey bg-white px-16 py-12 font-montserrat-medium text-l text-ink',
                    'placeholder:text-secondary-light-grey',
                    fullWidth ? 'input_full-width max-w-none' : 'max-w-[376px]',
                    resolvedState === 'error' && 'input_error border-error',
                    resolvedState === 'warning' && 'input_warning border-warning',
                    resolvedState === 'colored' && 'input_colored bg-clip-content bg-secondary-light-grey',
                    className,
                )}
                placeholder={placeholder}
                value={value ?? ''}
                onChange={onChange}
                {...rest}
            />
            {errorText ? (
                <p className="block__bullet error mt-12 text-error">{errorText}</p>
            ) : null}
            {!errorText && warningText ? (
                <p className="block__bullet warning mt-12 text-warning">{warningText}</p>
            ) : null}
        </div>
    );

    if (!label) {
        return field;
    }

    return (
        <label className="input__label mt-16 mb-20 flex flex-col gap-8" htmlFor={id}>
            <span className="block__text">{label}</span>
            {field}
        </label>
    );
};

export default Input;
